<div class="chat-container" (wheel)="onContainerScroll($event)">
  <div class="chat-messages" #chatContentElement (wheel)="onScroll($event)" (touchmove)="onTouchMove($event)">
    @for (message of messages; track message) {
      <div class="chat-message-container">
        @if (message.role == 'user') {
          <div class="user-message">
            @if (message.data.text) {
              <p [innerHTML]="message.data.text" class="text-style"></p>
            }
          </div>
        }
        @if (message.role == 'ai' || message.role == 'live_agent') {
          <div class="agent-message"
            [ngClass]='{"live-agent": message.role == "live_agent", "ai": message.role == "ai", "form-message": message.data.formRequest}'
            >
            @if (message.data.text) {
              <app-chat-markdown [html]="message.data.text" class="text-style"></app-chat-markdown>
            }
            @if (message.data.supportData) {
              <app-chat-support-link
              [supportData]="message.data.supportData"></app-chat-support-link>
            }
            @if (message.data.error) {
              <ng-container class="error-message"><p>{{message.data.error}}</p></ng-container>
            }
          </div>
        }
      </div>
    }
    @if (loading) {
      <div class="loader">
        <div class="typing">
          <span class="circle scaling"></span>
          <span class="circle scaling"></span>
          <span class="circle scaling"></span>
        </div>
      </div>
    }
    @if (liveAgentTypingLoader) {
      <div class="live-agent-typing-loader">
        <div class="typing">
          <span class="circle scaling"></span>
          <span class="circle scaling"></span>
          <span class="circle scaling"></span>
        </div>
      </div>
    }

  </div>
  <div class="chat-footer" >
    @if (micEnabled) {
      <app-chat-audio-level></app-chat-audio-level>
    }
  </div>
  <app-chat-input [disableInput]="disableInput" [buildingEntityList]="buildingEntityList" [loading]="loading"
    [config]="config" [chatScreenConfig]="chatScreenConfig" [isEmbedded]="true"
    [placeholder]="chatInputPlaceholderText" [sendIconEnabled]="true" [isInsideChartCommandPanel]="true"
    [showUserInputOptions]="chatAgentType === 'AI'" (toggleMic)="onToggleMic()" (keydown.enter)="onSubmit()"
  (sendMessgae)="onSubmit()" (mentions)="onMentions($event)" #chatInput></app-chat-input>
</div>
